import dayjs from "dayjs";

/**
 * 「最近一次问题时间」在前端内部值与后端提交/回显值之间的归一化工具。
 *
 * 前端内部值格式："YYYY-MM-DD HH:mm"，时/分「未知」以 "--" 标记
 *   - 时未知（连带分未知）："YYYY-MM-DD --:--"
 *   - 分未知（时已知）："YYYY-MM-DD HH:--"
 * 后端字段：合法 datetime（带秒）+ unknownPrecision（0-无 / 1-小时未知 / 2-分钟未知）
 *
 * 提交（collectSubmit）用 withSeconds + getUnknownPrecision；
 * 回显（hydrateCollectInfo）用 toInnerLastIssueTime。二者互逆，集中于此避免改一处漏一处。
 */

// 内部值 → 后端时间：界面精确到分钟，后端要求带秒，补 ":00"；
// 时/分「未知」标记（--）统一补零后再补秒（如 "2026-08-11 14:--" → "2026-08-11 14:00:00"）
export const withSeconds = (t: string): string => {
  if (!t) return "";
  const [d, time = ""] = t.split(" ");
  // 畸形输入（无时间段）兜底：保持原样不拼接，避免产出 "2026-08-11 :00" 脏值
  if (!time) return t;
  const normalized = time.replace(/--/g, "00");
  return `${d} ${normalized}:00`;
};

// 由内部时间值（可能含未知标记 --）推导后端「未知时间精度」unknownPrecision：
// 0-无（时分都已知）/ 1-小时（时未知，连带分未知）/ 2-分钟（分未知，时已知）
export const getUnknownPrecision = (t: string): number => {
  const [h = "", m = ""] = (t.split(" ")[1] || "").split(":");
  if (h === "--") return 1;
  if (m === "--") return 2;
  return 0;
};

// 后端时间（合法 datetime）+ unknownPrecision → 前端内部值（带未知标记 --）
// unknownPrecision：1-小时未知 → "--:--"；2-分钟未知 → "HH:--"；0/缺省 → "HH:mm"
export const toInnerLastIssueTime = (
  raw: any,
  unknownPrecision?: number
): string => {
  if (!raw || !dayjs(raw).isValid()) return "";
  const d = dayjs(raw);
  const date = d.format("YYYY-MM-DD");
  if (unknownPrecision === 1) return `${date} --:--`;
  if (unknownPrecision === 2) return `${date} ${d.format("HH")}:--`;
  return d.format("YYYY-MM-DD HH:mm");
};
